import { Extension, GlobalAttributes } from '@tiptap/core';

export const VolumeExtension = Extension.create({
  name: `volume`,
  addGlobalAttributes(): GlobalAttributes {
    return [
      {
        types: [`paragraph`],
        attributes: {
          dataType: {
            default: ``,
            keepOnSplit: false,
            renderHTML: ({ dataType }) =>
              dataType === `volume`
                ? {
                    style: `display: inline`
                  }
                : null,
            parseHTML: element => element.getAttribute(`data-type`)
          }
        }
      }
    ];
  }
});
